import React from 'react'
import { Flex, Text } from '@grammarly/design-system'

export interface WidgetHeaderProps {
  title: string
  icon?: JSX.Element
}

export const WidgetHeader: React.FC<WidgetHeaderProps> = ({ title, icon }) => {
  return (
    <Flex direction="row" align="center" justify="space-between">
      <Flex direction="row" align="center" gap={2}>
        {icon}
        <Text as="span" variant="text-small" weight="semibold" color="base-default">
          {title}
        </Text>
      </Flex>

      <InterfaceRightSmallIcon />
    </Flex>
  )
}

/**
 * Can be replaced after GDS will include it (likely in the 7.0.0 update).
 * See ChevronRightSmallIcon GDS / Figma for reference: https://www.figma.com/design/COYCZfTmbskjOUNCc6q1AI/Agent-Widget-Dashboard?node-id=992-19829&m=dev.
 */
const InterfaceRightSmallIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M8.92243 13.9225C8.59699 14.2479 8.06948 14.2479 7.74404 13.9225C7.41868 13.597 7.41863 13.0695 7.74404 12.7441L10.4882 9.99993L7.74404 7.25579L7.68707 7.19231C7.42019 6.865 7.43897 6.38248 7.74404 6.0774C8.04911 5.77233 8.53164 5.75355 8.85895 6.02044L8.92243 6.0774L12.2558 9.41074C12.5812 9.73618 12.5812 10.2637 12.2558 10.5891L8.92243 13.9225Z"
        fill="#707070"
      />
    </svg>
  )
}
